import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import type { ReactNode } from "react";
import { getCountryFlag, getCountryName } from "../../CountryName.tsx";

/**
 * A background job's name after the flag of the country whose data it syncs.
 * With ``reserve`` a job with no country keeps the flag's slot empty, so names
 * line up in a column of them.
 */
export default function JobName({
  country,
  reserve = false,
  children,
}: {
  country: string | null;
  reserve?: boolean;
  children: ReactNode;
}) {
  return (
    <Box component="span" sx={{ display: "inline-flex", alignItems: "center", gap: 0.75, minWidth: 0 }}>
      {(country || reserve) && (
        <Tooltip title={country ? getCountryName(country) : ""} disableHoverListener={!country}>
          <Box
            component="span"
            aria-label={country ? getCountryName(country) : undefined}
            sx={{ width: "1.4em", flexShrink: 0, textAlign: "center" }}
          >
            {country ? getCountryFlag(country) || country : ""}
          </Box>
        </Tooltip>
      )}
      <Box component="span" sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
        {children}
      </Box>
    </Box>
  );
}
